import styled from 'styled-components';

const Padder = styled.div`
  height: ${props => props.height ? props.height : '6px'};
  width: ${props => props.width ? props.width : '6px'};
`;

export default Padder;
